/**
*
*  How to use this script:
*
*  We need two elements, a vieport checker element and an image wrapper element.
*  To the 'viewport checker' element, add the class of 'js-viewport-checker'.
*  In the 'image wrapper' element, add the class of 'js-insert-img' and a 'data-img' attribute
*  with the value of the 'src' of the desired image.
*  When the checker element gets in the viewport, the image will appear inside the wrapper element.
*
*  If the checker element is the same as the wrapper element, just add 'js-viewport-checker' class and the 'data-img' attribute to it.
*
*  Same goes for text too.
*  Add the class "js-animated-text", no need for a 'viewport checker class' for just text, or plain elements
*
*  You should also check to scss/components/animations dicectory for the Styles.
*
**/

var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        // bounding.left >= 0 &&
        (bounding.bottom*5/6) <= (window.innerHeight || document.documentElement.clientHeight)
        // && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

function loadImg(i){
  var check = vpChecker[i];
  if (isInViewport(check)) {
    if( check.classList.contains('js-animated') ){
        //window.removeEventListener('scroll', loadImg, false);
    }else{
        check.classList.add('js-animated');
        // curClass = 'js-loaded-img-' + curClassInd;
        // curClassInd += 1;

        if(childrenOfChecker(i).length>0){
          for (var k = 0; k < childrenOfChecker(i).length; k++) {
            curClass = 'js-loaded-img-' + curClassInd;
            curClassInd += 1;
            if (childrenOfChecker(i)[k].classList.contains('service-item-image')) {
                childrenOfChecker(i)[k].innerHTML = '<img src="' + childrenOfChecker(i)[k].getAttribute('data-img') + '"' + 'class="' + curClass + ' service-item-image"' + 'height="350">';
            }else{
                childrenOfChecker(i)[k].innerHTML = '<img src="' + childrenOfChecker(i)[k].getAttribute('data-img') + '"' + 'class="' + curClass + '"' + 'height="350">';
            }
            document.querySelector('.'+curClass).classList.add('appear');
            //var btmBorder = window.getComputedStyle(childrenOfChecker(i)[k], ':after').getPropertyValue('bottom');
            //childrenOfChecker(i)[k].classList.add('appear');
          }
        // }else if ( !childrenOfChecker(i).classList.contains('js-insert-img') ){
        }else{
          curClass = 'js-loaded-img-' + curClassInd;
          curClassInd += 1;
          if (check.classList.contains('service-item-image')) {
            check.innerHTML = '<img src="' + check.getAttribute('data-img') + '"' + 'class="' + curClass + ' service-item-image"' + 'height="300">';
            // document.querySelector('.'+curClass).classList.add('appear');
          }else {
            check.innerHTML = '<img src="' + check.getAttribute('data-img') + '"' + 'class="' + curClass + '"' + 'height="300">';
          }
          document.querySelector('.'+curClass).classList.add('appear');
        }
    }
  }
}

function animateSection(i){
  window.addEventListener('scroll', function (event) {
    loadImg(i);
  }, false);
}

function loadText(i){
  var text = textToAnimate[i];
  if (isInViewport(text)) {
      if( text.classList.contains('js-animated') ){

      }else{
          text.classList.add('js-animated');
          curTextClass = 'js-loaded-text-' + curTextInd;
          curTextInd += 1;
          text.classList.add(curTextClass);
          text.classList.add('appear');
      }
  }
}

function animateText(i){
  window.addEventListener('scroll', function (event) {
    loadText(i);
  }, false);
}


// checks if viewport-checker element has children with class of 'js-insert-img', and returns those children
var childrenOfChecker = function(j){
  try{
    var cld = [];
      var children = vpChecker[j].children;
      for (var i = 0; i < children.length; i++) {
          //console.log(children[i]);
          try{
            if (children[i].classList.contains("js-insert-img")) {
              cld.push(children[i]);
            }
          }catch(e){
            console.warn(e);
          }
      }
  }catch (e){
    console.warn(e);
  }
  return cld;
}

var curClass = 'js-loaded-img-';
var curClassInd = 0;
var vpChecker = document.querySelectorAll('.js-viewport-checker');
var textToAnimate = document.querySelectorAll('.js-animated-text');
var curTextInd = 0;
var curTextClass = 'js-loaded-text-';

for(let i=0; i < vpChecker.length; i++){
  //console.log(vpChecker[i]);
  if(isInViewport(vpChecker[i])){
    loadImg(i);
  }else{
    animateSection(i);
  }
}
for (var i = 0; i < textToAnimate.length; i++) {
  if (isInViewport(textToAnimate[i])) {
    loadText(i);
  }else{
    animateText(i);
  }
}
